module.exports = __webpack_public_path__ + "static/media/blog-11.18c4d390.svg";